import { SequenceStatus } from '../../../shared/models/sequenceStatus.enum';
import { ToastAnt } from '../../Shared/Toast/ToastAnt';
import { AnnotationsForGrid, MLAssessmentScore, SequenceStatusInfo } from './annotation.types';

export function prepareTreeAdditionalData(sequenceStatuses: SequenceStatusInfo[]) {
  if (!sequenceStatuses) {
    return null;
  }

  return sequenceStatuses.map(x => ({
    bladePath: `${x.blade}/${x.bladeSide}`,
    additional: `${x.annotationsToBeTransferredCount.toString()}/${x.annotationsCount.toString()}`,
    haveQC: x.haveQC,
    mlScore: x.mlAssessmentScore
  }));
}

export function enableCheck(right: boolean) {
  return {
    top: false,
    right,
    bottom: false,
    left: false,
    topRight: false,
    bottomRight: false,
    bottomLeft: false,
    topLeft: false
  };
}

export const findingProps = [
  { title: 'Severity', value: 'Severity' },
  { title: 'Category', value: 'findingTypeName' },
  { title: 'Layer', value: 'Layer' },
  { title: 'Width[mm]', value: 'WidthMm' },
  { title: 'Height[mm]', value: 'HeightMm' },
  { title: 'Distance To Root[M]', value: 'DistanceToRootM' },
  { title: 'Distance To LE[M]', value: 'DistanceToLeadingEdgeM' }
] as const;

const severityColors = ['#fcd5a6', '#fab45e', '#ee753f', '#c8c1ce', '#ba0e49', '#b9b9b9'];

export const getSeverityPropValue = (annotation: AnnotationsForGrid) => {
  const severityPropValue = annotation.properties.find(x => x.name === 'Severity');

  if (!severityPropValue) {
    return;
  }

  return +severityPropValue.value;
};

export const getSeverityColor = (value: number) => {
  return severityColors[value - 1];
};

export const getPropertyBackgroundColor = (title: string, value: any) => {
  if (title === 'Severity') {
    return getSeverityColor(value);
  }
  return '';
};

export const INITIAL_TREE_WIDTH = 21.2;
export const MIN_TREE_WIDTH = 3;
export const MAX_TREE_WIDTH = 26;

export const INITIAL_IMAGES_VIEW_WIDTH = 30;
export const MIN_IMAGES_VIEW_WIDTH = 7;
export const MAX_IMAGES_VIEW_WIDTH = 35;

export const AnnotationManagerPrefix = 'annotation-manager';

export type FindingOverlayCardType = {
  Severity: string;
  findingType: string;
  Layer: string;
  WidthMm: string;
  HeightMm: string;
};

export const getMLScoreContent = (mlScore: MLAssessmentScore | undefined) => {
  if (!mlScore) {
    return '';
  }

  switch (mlScore) {
    case MLAssessmentScore.NotUsable:
      return 'The metadata is not usable at all';
    case MLAssessmentScore.PartiallyUsable:
      return 'The data can be partially used only';
    case MLAssessmentScore.MajorAdjustmentNeeded:
      return 'Major manual adjustment is needed';
    case MLAssessmentScore.MinorAdjustmentNeeded:
      return 'Minor manual adjustment is needed';
    case MLAssessmentScore.CanProcesAutomatically:
      return 'The data can be automatically processed';
    default:
      return '';
  }
};

export const isSequenceValidForAnnotation = (path: string, sequenceStatuses: SequenceStatusInfo[]) => {
  const sequenceStatusInfo = sequenceStatuses.find(x => x.sequencePath === path);

  if (!sequenceStatusInfo) {
    ToastAnt('Sequence does not exist');
    return false;
  }

  if (sequenceStatusInfo.status !== SequenceStatus.ManualStitchingNotNeeded) {
    if (sequenceStatusInfo.status < SequenceStatus.ManualStitchingCompleted) {
      ToastAnt('Stitching review is not completed for the sequence');
      return false;
    }

    if (
      sequenceStatusInfo.useMlFindingDetection !== false &&
      sequenceStatusInfo.status < SequenceStatus.MlReviewCompleted &&
      sequenceStatusInfo.status !== SequenceStatus.MlReviewFailed
    ) {
      ToastAnt('ML annotation service result is not received for the sequence');
      return false;
    }
  }

  return true;
};

export const removeFocusFromCurrentElement = () => {
  var footer = document.getElementById('focus-dummy');
  if (footer) {
    footer?.focus();
  }
};
